const baseUrl = "/v1/sync-image-upload"
export const API_URL = {
    UPLOAD : `${baseUrl}`,
    GET_DETAILS:`/v1/sync-details`,
    UPDATE_DETAILS: `/v1/update-sync
`
}